import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { withRouter, Link } from 'react-router-dom';
import HamburgerMenu from 'react-hamburger-menu';

import './navcontainer.css';
import SmallModal from './SmallModal';
import SettingsMenu from './SettingMenu';
import LinkMenu from './LinkMenu'

class NavContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isShowSetting: false,
            isModalOpen: false,
        }
    }
    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }
    handleClickOutside = event => {
        const domNode = ReactDOM.findDOMNode(this);
        if (!domNode || !domNode.contains(event.target)) {
            this.setState({
                isModalOpen: false,
                isOpen: false,
                isShowSetting: false,
            });
        }
    }
    handleMenuClick = (type) => {
        // console.log("clicked")
        let isOpen = this.state.isOpen;
        let isShowSetting = this.state.isShowSetting;
        let isModalOpen = false;
        if (type === 'setting') {
            isModalOpen = isShowSetting ? false : true;
            isShowSetting = !isShowSetting;
            isOpen = false;
        }
        else {
            isModalOpen = isOpen ? false : true;
            isOpen = !isOpen;
            isShowSetting = false;
        }
        this.setState({ isModalOpen, isOpen, isShowSetting })
    }
    toggleModal = (isModalOpen) => {
        this.setState({ isModalOpen })
    }
    childSettings = (payload) => {
        if (this.props.giveSettings){
            this.props.giveSettings(payload)
        }
    }
    render() {
        let { isModalOpen, isOpen, isShowSetting } = this.state;

        return (
            <div className="navigation-container">
                <button className="setting-btn" onClick={() => this.handleMenuClick('setting')}>
                    <i className="fa fa-cog" />
                </button>
                <HamburgerMenu
                    isOpen={isOpen}
                    menuClicked={() => this.handleMenuClick('hamburger')}
                    className="hamburger"
                    width={26}
                    height={16}
                    strokeWidth={4}
                    rotate={0}
                    color='black'
                    borderRadius={1}
                    animationDuration={0.5}
                />
                <SmallModal isModalOpen={isModalOpen}>
                    {isShowSetting ? <SettingsMenu settingObj={this.props.settingObj} childSettings={this.childSettings}  toggleModal={this.toggleModal} /> : <LinkMenu />}
                </SmallModal>
            </div>
        )
    }
}
export default withRouter(NavContainer);